export enum ChipVariant {
  SUCCESS,
  WARNING,
  ERROR
}

